import { MapGrouping } from './map-grouping';
import { Layers } from './map-layer';
import { IdlePoseObject } from '../objects/idle-pose-object';
import { IdlePose, IdlePoseType } from '../../models/idle-pose';
import { Pose } from '@ng-cloud/badger-core/models/pose';

@Layers([
  { name: 'idlePoses', zIndex: 7 }
])
export class IdlePoseGrouping extends MapGrouping<IdlePose, IdlePoseObject> {

  createObject(idlePose: IdlePose): IdlePoseObject {
    return new IdlePoseObject(idlePose, this.storeMap.poseToPixels(idlePose.pose), this.options);
  }

  addPoses(poses: Pose[]) {
    let idlePoses: IdlePose[] = []
    poses.forEach(pose => {
      let newPose = new IdlePose();
      newPose.pose = pose;
      newPose.poseType = pose.poseType == IdlePoseType.Park.toLowerCase() ? IdlePoseType.Park : IdlePoseType.Dock;
      idlePoses.push(newPose);
    })
    this.setData(idlePoses);
  }
}
